import React, { useEffect, useState, useRef } from "react";
import classes from "./style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import SuccessImage from "../../assets/images/icons/checkContainedIcon.png";
import FooladLogo from "../../assets/images/icons/fooladLogo.svg";
import QRCode from "react-fancy-qrcode";
import { useParams, useSearchParams } from "react-router-dom";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import Loading from "../../assets/containers/loadingDialog";
import { convertToShamsi } from "../../assets/utils/ConvertToShamsi";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../assets/components/CustomButton";
import { MdDelete } from "react-icons/md";
import CancellDialog from "./CancellDialog";
import { useDispatch } from "react-redux";
import UsersRequests from "../../assets/services/user";
import Hint from "../../assets/components/Hint";

const AwardRreceipt = () => {
  const qrContainerRef = useRef(null);
  const [qrSize, setQrSize] = useState(0);
  const [prizeInfo, setPrizeInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [showCancellDialog, setShowCancellDialog] = useState(false);
  const navigate = useNavigate();

  const { id } = useParams();

  const dispatch = useDispatch();

  const updateQrSize = () => {
    if (qrContainerRef.current) {
      setQrSize(qrContainerRef.current.clientWidth - 36);
    }
  };

  const [searchParams] = useSearchParams();
  const showMessage = searchParams.get("showMessage");

  const getPrize = async () => {
    setLoading(true);
    try {
      await appApi
        .get(`/pointshop/purchase/user/history/getsingle/${id}`)
        .then(({ data }) => {
          setPrizeInfo(data);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      navigate("..", { replace: true });
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrize();
    updateQrSize();
    window.addEventListener("resize", updateQrSize);
    return () => window.removeEventListener("resize", updateQrSize);
  }, []);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {!showMessage && (
          <div className={classes.imageContainer}>
            <img src={SuccessImage} alt="success pic" />
            <p>خرید شما با موفقیت انجام شد.</p>
          </div>
        )}
        <div className={classes.tecketDetailsContainer}>
          <div>
            <p>کد رهگیری :</p>
            <p>{id}</p>
          </div>
        </div>
        <div className={classes.barcodeContainer} ref={qrContainerRef}>
          <QRCode
            logo={FooladLogo}
            removeQrCodeBehindLogo
            value={JSON.stringify({
              _id: id,
              type: "PointShop",
            })}
            dotScale={0.8}
            dotRadius="50%"
            positionRadius={["5%", "1%"]}
            size={qrSize}
            errorCorrection="H"
          />
          <p className="text-center mt-3 mb-0">{prizeInfo?.item?.name}</p>
        </div>
        <div className={classes.awardinfo}>
          {loading ? (
            <Loading
              className={"w-100 d-flex justify-content-center my-5 py-5"}
            />
          ) : (
            prizeInfo && (
              <div>
                <div className={classes.infoRow}>
                  <div className={classes.infoTitle}>نام جایزه :</div>
                  <div className={classes.infoValue}>
                    {prizeInfo?.item?.name}
                  </div>
                </div>
                <div className={classes.infoRow}>
                  <div className={classes.infoTitle}>قیمت:</div>
                  <div className={classes.infoValue}>
                    {prizeInfo?.purchasePrice}
                  </div>
                </div>
                <div className={classes.infoRow}>
                  <div className={classes.infoTitle}>تاریخ:</div>
                  <div className={classes.infoValue}>
                    {convertToShamsi(prizeInfo?.createdAt)}
                  </div>
                </div>
                <div className={classes.infoRow}>
                  <div className={classes.infoTitle}>دریافت شده:</div>
                  <div className={classes.infoValue}>
                    {prizeInfo?.attended ? "بلی" : "خیر"}
                  </div>
                </div>
                <div className={classes.infoRow}>
                  <div className={classes.infoTitle}>تحویل شده توسط:</div>
                  <div className={classes.infoValue}>
                    {prizeInfo?.attendantName || "_"}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
        {prizeInfo?.item?.deliveryNote && (
          <div className={classes.guidContainer}>
            <p
              dangerouslySetInnerHTML={{
                __html: prizeInfo?.item?.deliveryNote,
              }}
            />
          </div>
        )}
        <div className="mt-3">
          {prizeInfo?.expireDateForCancel && (
            <Hint
              hintText={`جایزه خریداری شده تا تاریخ ${convertToShamsi(
                prizeInfo?.expireDateForCancel
              )} قابلیت لغو دارد.`}
            />
          )}
          {prizeInfo?.expireDateForItem && (
            <Hint
              hintText={`جایزه خریداری شده تا تاریخ ${convertToShamsi(
                prizeInfo?.expireDateForItem
              )} مهلت دریافت دارد.`}
            />
          )}
        </div>
        {prizeInfo?.item?.cancellSetting?.enabled &&
          prizeInfo?.attended === false &&
          prizeInfo?.cancelled === false &&
          prizeInfo?.expired === false && 
          prizeInfo?.removed === false && (
            <div className="d-flex justify-content-center">
              <CustomButton
                clickHandler={() => setShowCancellDialog(true)}
                styles={{
                  backgroundColor: "red",
                  paddingInline: "30px",
                }}
                text={
                  <div className="d-flex align-items-center justify-content-center">
                    <MdDelete size={25} className="ml-3" />
                    لغو
                  </div>
                }
              />
            </div>
          )}
      </div>
      <CancellDialog
        open={showCancellDialog}
        close={() => setShowCancellDialog(false)}
        handleConirm={async () => {
          setLoading(true);
          try {
            await appApi.delete(`/pointshop/purchase/remove/${id}`).then(() => {
              dispatch(UsersRequests.getUserPoint());
              navigate("..", { replace: true });
            });
          } catch (error) {
            errorHandler(error);
            setLoading(false);
          }
        }}
      />
    </AnimatedPageContainer>
  );
};

export default AwardRreceipt;
